/**
 * Размеры изображений для универсального блока по ширине
 * @type {Object}
 */
export var UNIVERSAL_IMAGE_SIZES = {
  s: 40,
  m: 60,
  l: 120
};

/**
 * Размеры изображений для таблиц по высоте
 * @type {Object}
 */
export var TABLE_IMAGE_SIZES = {
  xs: 16,
  s: 18,
  m: 20,
  l: 24,
  xl: 36,
  xxl: 40
};

/**
 * Размеры изображений для кнопок
 * @type {Object}
 */
export var BUTTON_IMAGE_SIZES = {
  m: 24
};

/**
 * Вычислить размер по
 * @type {Object}
 */
export var SCALE_BY = {
  height: 'height',
  width: 'width'
};

/**
 * Значения кропа изображения
 * @type {Object}
 */
export var CROP = {
  top: 'top',
  center: 'center'
};